const styles = {
  imageWrap: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    boxShadow: 'none',
  },
  image: {
    backgroundSize: 'contain',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
};

export default styles;
